import { graphql, useStaticQuery } from 'gatsby';
import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Flag } from '@opswat/ui';

type CountryCode = ComponentProps<typeof Flag>['countryCode'];

const languageFlags: Record<string, CountryCode> = {
    'en': 'US',
    'ja': 'JP',
};

export const useLanguage = () => {
    const { i18n } = useTranslation();
    const { resolvedLanguage, changeLanguage } = i18n;
    const lngName = new Intl.DisplayNames(['en'], { type: 'language' });

    const data = useStaticQuery(graphql`
        {
            allFile(filter: { extension: { eq: "json" } }) {
                edges {
                    node {
                        name
                    }
                }
            }
        }
    `);

    const lngCodes: string[] = data?.allFile?.edges?.map((edge: { node: { name: string; }; }) => edge.node.name) ?? [];

    const languages = lngCodes
        .toSorted((a, b) => {
            if (a === 'en') {
                return -1;
            }
            if (b === 'en') {
                return 1;
            }
            return a.localeCompare(b);
        })
        .map((lng) => ({
            code: lng,
            name: lngName.of(lng) ?? lng,
            flag: languageFlags[lng],
            isSelected: resolvedLanguage === lng,
        }));
    
    const currentLanguage = languages.find(({ code }) => code === resolvedLanguage);
    
    return { languages, currentLanguage, changeLanguage };
};
